export var EPartialCheckboxValue;

(function (EPartialCheckboxValue) {
  EPartialCheckboxValue[EPartialCheckboxValue["None"] = 0] = "None";
  EPartialCheckboxValue[EPartialCheckboxValue["All"] = 1] = "All";
  EPartialCheckboxValue[EPartialCheckboxValue["Partial"] = 2] = "Partial";
})(EPartialCheckboxValue || (EPartialCheckboxValue = {}));